import { RONDE_GRANTED_DIRECTION_RANDOM, RONDE_GRANTED_DIRECTION_REVERSE, RONDE_LIBRE } from '@/consts/rondes'
import { TYPE_CHECKPOINT_GEOLOCATED } from '@/consts/events'

export default {

  /**
   * Les rondes du service actif
   * @param state
   * @param getters
   * @returns {[]}
   */
  rondes: (state, getters) => {
    return _.get(getters, ['serviceActif', 'rounds'], [])
      .map((r) => ({
        ...r,
        serviceRoundExecutions: getters.serviceRoundExecutionsByServiceRound[r.id]
      }))
  },

  /**
   * Les executions de ronde du service actif
   * @param state
   * @param getters
   * @returns {[]}
   */
  serviceRoundExecutions: (state, getters) => {
    return _.get(getters, ['serviceActif', 'serviceRoundExecutions'], [])
  },

  /**
   * Les services roundExecutions indéxé par id
   * @param state
   * @param getters
   */
  serviceRoundExecutionsByServiceRound: (state, getters) => {
    return _.groupBy(getters.serviceRoundExecutions, 'serviceRound.id')
  },

  /**
   * Les rondes indexées par reference
   * @param state
   * @param getters
   * @returns {{}}
   */
  keyedRondes: (state, getters) => _.keyBy(getters.rondes, 'id'),

  /**
   * Récupère la ronde active
   * @param state
   * @param getters
   * @returns {*|null}
   */
  rondeActive: (state, getters) => {
    return getters.serviceRoundExecutionActif
      ? getters.serviceRoundExecutionActif.serviceRound
        ? getters.keyedRondes[getters.serviceRoundExecutionActif.serviceRound.id]
        : {
          round: RONDE_LIBRE
        }
      : null
  },

  /**
   * Le ServiceRoundExecution actif
   * @param state
   * @param getters
   * @returns {*}
   */
  serviceRoundExecutionActif: ({ rondeActive }, { serviceRoundExecutions }) => {
    return serviceRoundExecutions.find((s) => s.id === rondeActive)
  },

  /**
   * Les events relatifs à la rond active (point controle)
   * @param state
   * @param getters
   */
  serviceRoundExecutionActifEvents: ({ rondeActive }, { serviceEvents }) => {
    return rondeActive
      ? serviceEvents.filter((e) =>
        e.serviceRoundExecution &&
        e.serviceRoundExecution.id === rondeActive)
      : []
  },

  /**
   * Les events relatifs aux checkpoints de la rond active (point controle)
   * @param state
   * @param getters
   */
  serviceRoundExecutionActifCheckpointsEvents: (state, getters) => {
    return getters.serviceRoundExecutionActifEvents.filter((e) => e.roundCheckpoint)
  },

  /**
   * Liste les checkpoints de la ronde active
   * @param state
   * @param rondeActive
   * @returns {*}
   */
  checkpoints: (state, { rondeActive }) => _.get(rondeActive, ['round', 'checkpoints'], []),

  /**
   * Retourne le ou les prochains points de contrôle de la ronde active
   * @returns {[]}
   */
  prochainCheckpoints: (state, {
    rondeActive,
    checkpoints,
    serviceRoundExecutionActifCheckpointsEvents,
    allValidated
  }) => {
    if (!rondeActive) return null
    const { round } = rondeActive
    if (!round) return null
    if (allValidated) {
      return []
    }
    const { grantedDirections = [] } = round
    if (grantedDirections.indexOf(RONDE_GRANTED_DIRECTION_RANDOM.value) !== -1) {
      return null
    }
    if (serviceRoundExecutionActifCheckpointsEvents.length > 0) {
      const r = []
      const lastId = _.get(_.head(serviceRoundExecutionActifCheckpointsEvents), ['roundCheckpoint', 'id'])
      const lastIndex = checkpoints.findIndex((roundCp) => roundCp.id === lastId)
      const nextIndex = checkpoints.length === lastIndex + 1
        ? 0
        : lastIndex + 1
      const nextCheckpoint = checkpoints[nextIndex]
      if (nextCheckpoint) {
        r.push(nextCheckpoint)
      }
      if (grantedDirections.indexOf(RONDE_GRANTED_DIRECTION_REVERSE.value) !== -1) { // Sens inverse autorisé
        const nextIndex = lastIndex - 1 > 0
          ? lastIndex - 1
          : checkpoints.length - 1
        r.push(checkpoints[nextIndex])
      }
      return r
    }
    return checkpoints[0]
      ? [checkpoints[0]]
      : []
  },

  /**
   * Indexe les checkpoints de la ronde active
   * @param state
   * @param serviceRoundExecutionActifEvents
   * @returns {*}
   */
  indexedCheckpoints (state, { serviceRoundExecutionActifEvents }) {
    return _.keyBy(serviceRoundExecutionActifEvents, (e) => e.roundCheckpoint
      ? e.roundCheckpoint.id
      : 'virtual-' + e.id
    )
  },

  /**
   * Calcule les checkpoints "virtuels"
   * @returns {[]}
   */
  virtualCheckpoints (state, { serviceRoundExecutionActifEvents }) {
    return serviceRoundExecutionActifEvents
      .filter((e) => e.type.typeKey === TYPE_CHECKPOINT_GEOLOCATED.typeKey)
      .map(({ id, createdAt, ...e }) => ({
        id: 'virtual-' + id,
        validatedAt: createdAt,
        checkpoint: {
          ...e,
          title: 'Point de contrôle géolocalisé',
          color: '#4caf50'
        }
      }))
  },

  /**
   * Liste de tous les checkpoints géolocalisés combiné avec ceux planifiés
   * @returns {{_index}[]}
   */
  vCheckpoints (state, { virtualCheckpoints, checkpoints, indexedCheckpoints }) {
    return _.sortBy(
      [
        ...virtualCheckpoints,
        ...checkpoints.map((p) => ({
          ...p,
          color: indexedCheckpoints[p.id]
            ? '#4caf50'
            : null,
          validatedAt: indexedCheckpoints[p.id] && indexedCheckpoints[p.id].createdAt
        }))
      ],
      'validatedAt').map((c, i) => ({ ...c, _index: i + 1 }))
  },

  /**
   * Détermine si tous les checkpoints ont été validés
   * @param store
   * @param vCheckpoints
   * @returns {*}
   */
  allValidated: (store, { vCheckpoints }) => {
    return vCheckpoints.every(checkpoint => checkpoint.validatedAt)
  }
}
